import * as actionTypes from './actionTypes';
import axiosGolang from 'lib/axios/axios-golang';
import axiosOauthGolang from '../../lib/axios/axios-oauth-golang';
import { getDeviceDetails } from 'helpers/getDeviceDetails';
import { getPartnerId } from 'helpers/getPartnerId';

import {
  STANDARD_TEXT,
  CUSTOM_USERS,
  USERS,
  OAUTH,
  SPLASH,
  DEVICE_REG,
  PROFILE,
  CHANGE_PHONE_NUMBER,
  CHANGE_PIN,
  AUTH_MODE,
  CUSTOM_RAYANET,
  VALIDATE_TOKEN,
  CUSTOM_DEVICE_LOCATION,
  LOGOUT,
  CUSTOM_PARTNER,
  USER_CONSENT,
  SYNC_PHONE_NUMBER
} from '../../common/config';
import { loading, setApplicationStatus } from './loanApply';
import {
  getChannelContextAdditionalInfo,
  getChannelContextCode
} from '../../helpers/Utility';
import { sendEventRegist } from 'helpers/analytics';
import {
  handleErrorCreateAccount,
  handleErrorCreatePin,
  handleErrorPhoneRegistration,
  handleErrorUpdatePhoneNumber,
  handleErrorValidateOtp,
  handleRegisterOtpError
} from './handleErrorService/authenticateErrorService';
import {
  handleSuccessCreateAccount,
  handleSuccessUpdatePhoneNumber,
  handleSuccessValidateOtp
} from './handleSuccessService/authenticateSuccessService';
import { encryptOtpWithPublicKey } from 'helpers/otpEncryption';
import { encryptRSA } from 'helpers/rsaEncrypter';
import { setCookie } from 'helpers/saveToCookies';
import { handleAuthError } from './handleErrorService/authenticateErrorService';
import { setForgotPinNewPinAlreadyUsed } from './forgotPin';

export const setError = message => {
  return {
    type: actionTypes.SET_ERROR,
    error: message
  };
};

export const setAppTnC = data => {
  return {
    type: actionTypes.SET_APP_TNC,
    appTnC: data
  };
};

export const setIsTncAgreement = value => {
  return {
    type: actionTypes.SET_IS_TNC_AGREEMENT,
    isTncAgreement: value
  };
};

export const setUserId = phoneNo => {
  localStorage.setItem('phonePrincipal', phoneNo);
  return {
    type: actionTypes.SET_USER_ID,
    phonePrincipal: phoneNo
  };
};

export const setPhoneNo = phoneNo => {
  localStorage.setItem('phoneNo', phoneNo);
  return {
    type: actionTypes.SET_PHONE_NUMBER,
    phoneNo: phoneNo
  };
};

export const setPhoneNoRaya = noHpRaya => {
  localStorage.setItem('noHpRaya', noHpRaya);
  return {
    type: actionTypes.SET_PHONE_NUMBER_RAYA,
    noHpRaya: noHpRaya
  };
};

export const setPhoneNumberFlexiNew = noHpFlexiNew => {
  localStorage.setItem('noHpFlexiNew', noHpFlexiNew);
  return {
    type: actionTypes.SET_PHONE_NUMBER_FLEXI_NEW,
    noHpFlexiNew: noHpFlexiNew
  };
};

export const setNewPhoneNo = phoneNo => {
  return {
    type: actionTypes.SET_NEW_PHONENO,
    phoneNo: phoneNo
  };
};

export const setRegisteredPin = pin => {
  return {
    type: actionTypes.SET_REG_PIN,
    pin: pin
  };
};

export const setOauthToken = (token, expiredTime) => {
  return {
    type: actionTypes.SET_OAUTH_TOKEN,
    token: token,
    expiredTime: expiredTime
  };
};

export const resetTypedPin = () => {
  return { type: actionTypes.RESET_TYPED_PIN };
};

export const inputPin = pin => {
  return {
    type: actionTypes.TYPING_PIN,
    typedPin: pin
  };
};

export const newPin = pin => {
  return {
    type: actionTypes.SET_NEW_PIN,
    newPin: pin
  };
};

export const delPin = () => {
  return {
    type: actionTypes.DEL_PIN
  };
};

export const setHomePath = path => {
  return {
    type: actionTypes.SET_HOME_PATH,
    path: path
  };
};

export const setIsLogin = status => {
  return {
    type: actionTypes.SET_IS_LOGIN,
    status: status
  };
};

export const setUserProfile = data => {
  return {
    type: actionTypes.SET_PROFILE_DATA,
    data: data
  };
};

export const setInfoPromoPermission = status => {
  return {
    type: actionTypes.SET_PERMISSION_INFO_PROMO,
    status: status
  };
};

export const setParameterAccess = params => {
  return {
    type: actionTypes.SET_PARAMETER_ACCESS,
    params: params
  };
};

export const setDeviceInformation = deviceInformation => {
  return {
    type: actionTypes.SET_DEVICE_INFORMATION,
    deviceInformation: deviceInformation
  };
};

export const resetLogout = () => {
  return {
    type: actionTypes.RESET_LOGOUT
  };
};

export const setDataRayaApps = data => {
  return {
    type: actionTypes.SET_DATA_RAYA_APPS,
    data: data
  };
};

export const setStatusAuthFlowRaya = params => {
  return {
    type: actionTypes.SET_STATUS_AUTH_FLOW_RAYA,
    statusAuthFlowRaya: params
  };
};

export const setCodeAuthFlowRaya = params => {
  return {
    type: actionTypes.SET_CODE_AUTH_FLOW_RAYA,
    statusCodeFlowRaya: params
  };
};

export const setIsRayaAgreement = params => {
  return {
    type: actionTypes.SET_IS_RAYA_AGREEMENT,
    isRayaAgreement: params
  };
};

export const setErrorRayaAgreement = params => {
  return {
    type: actionTypes.SET_ERROR_RAYA_AGREEMENT,
    errorRayaAgreement: params
  };
};

export const setUpdateAgreement = value => {
  return {
    type: actionTypes.SET_UPDATE_TNC_AGREEMENT,
    updateTncAgreement: value
  };
};

export const setPermissionGeolocation = value => {
  return {
    type: actionTypes.SET_PERMISSION_GEOLOCATION,
    permission: value
  };
};

export const setSplashScreen = data => {
  const text = 'Kamu bisa dapetin pinjaman hingga 25jt dengan tenor 7 hari.';
  const text2 = 'Pakai pembayaran cicilan menggunakan autodebet tanpa ribet!';

  const splashData = data.filter(function (value, index) {
    return index !== 1;
  });
  const newState = splashData.map((obj, index) => {
    if (index === 0) {
      obj = { ...obj, description: text };
    } else if (index === 2) {
      obj = { ...obj, description: text2 };
    }
    return obj;
  });

  return {
    type: actionTypes.SET_SPLASH_SCREEN,
    data: newState
  };
};

export const setPosition = position => {
  return {
    type: actionTypes.SET_POSITION,
    position: position
  };
};

export const setResulValidateToken = result => {
  return {
    type: actionTypes.SET_RESULT_VALIDATE_TOKEN,
    resultValidateToken: result
  };
};

export const setHasLoginSession = hasLoginSession => {
  return {
    type: actionTypes.SET_HAS_LOGIN_SESSION,
    hasLoginSession: hasLoginSession
  };
};

export const splashScreen = action => {
  return (dispatch, getState) => {
    dispatch(loading(true));
    const header = {
      headers: {
        Authorization: getState().auth.VTtoken
      }
    };

    axiosGolang
      .get(SPLASH, header)
      .then(res => {
        dispatch(setSplashScreen(res.data.data));
        action(prev => !prev);
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const fetchAppTnC = (auth, param) => {
  return dispatch => {
    const config = { headers: { Authorization: auth.token } };
    !param?.notLoading && dispatch(loading(true));
    const linkSchemeCode =
      param.schemeCode !== 'KSBON' ? '&schemeCode=' + param.schemeCode : '';
    const linkSubCode = param.subCode ? '&subCode=' + param.subCode : '';
    axiosGolang
      .get(
        STANDARD_TEXT + param.textType + linkSchemeCode + linkSubCode,
        config
      )
      .then(res => {
        if (res.data.data) {
          param.push && param.push();
          dispatch(setAppTnC(res.data.data));
        } else {
          dispatch(setError('system'));
        }
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const phoneRegistration = (phoneNo, history, haveAccount, action) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const isFromRayaApps = getState()?.auth?.codeAuthFlowRaya;
    const encryptedPhone = await encryptRSA(phoneNo);

    const body = {
      userDetail: {
        userPhoneNumber: encryptedPhone
      },
      isTncAgreement:
        haveAccount || isFromRayaApps ? 'Y' : getState().auth.isTncAgreement
    };

    axiosGolang
      .post(CUSTOM_USERS, body)
      .then(() => {
        //return 200 if only number not registered yet
        //if click register button
        if (!haveAccount) {
          dispatch(setPhoneNo(phoneNo));
          localStorage.removeItem('phoneNo', phoneNo);
          sendEventRegist({
            action: 'User Regist the Number',
            label: 'phone number'
          });
          dispatch(setApplicationStatus(''));
          history.push('/create-pin');
          return;
        }

        action?.();
      })
      .catch(err => {
        const status = err?.response?.status;

        handleErrorPhoneRegistration(
          err,
          status,
          dispatch,
          haveAccount,
          action,
          phoneNo,
          history
        );
      })
      .finally(() => dispatch(loading(false)));
  };
};

//register
export const registerOTP = (token, phoneNumber, callback) => {
  return dispatch => {
    dispatch(loading(true));

    const diff = {
      deviceType: 'pg-wv-dc-typ-',
      deviceName: 'pg-wv-',
      deviceId: 'pg-wv-dc-id-'
    };

    const body = {
      deviceDetails: getDeviceDetails(phoneNumber, diff),
      isHPNumberChanged: 'N'
    };

    const header = {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    };

    const url = '/v1/banks/01/users' + DEVICE_REG;

    axiosGolang
      .put(url, body, header)
      .then(res => res)
      .catch(err => handleRegisterOtpError(err, dispatch, callback))
      .finally(() => dispatch(loading(false)));
  };
};

export const validateOTP = (phoneNumber, token, otp, action) => {
  return async dispatch => {
    dispatch(loading(true));

    const encryptedOtp = await encryptOtpWithPublicKey(otp);

    const diff = {
      deviceType: 'pg-wv-dc-typ-',
      deviceName: 'pg-wv',
      deviceId: 'pg-wv-dc-id-'
    };

    const body = {
      authorizationDetails: { oneTimePassword: encryptedOtp },
      deviceDetails: getDeviceDetails(phoneNumber, diff),
      isHPNumberChanged: 'N'
    };

    const header = {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    };

    const url = '/v1/banks/01/users' + DEVICE_REG;

    axiosGolang
      .put(url, body, header)
      .then(res => {
        if (res.status === 200)
          return handleSuccessValidateOtp(dispatch, action);
      })
      .catch(err => {
        const status = err?.response?.status;

        handleErrorValidateOtp(err, status, dispatch, action, phoneNumber);
      });
  };
};

export const createPin = (pin, phoneNumber, callback) => {
  return async (dispatch, getState) => {
    dispatch(loading(true));
    const isFromRayaApps = getState()?.auth?.codeAuthFlowRaya;
    const encryptedPhone = await encryptRSA(phoneNumber);
    const encryptedPin = await encryptRSA(pin);

    const body = {
      passwordDetails: {
        reTypesignOnPassword: encryptedPin,
        signOnPassword: encryptedPin,
        signOnPasswordFlag: 'Y',
        transactionPasswordFlag: 'Y'
      },
      userDetail: {
        userPhoneNumber: encryptedPhone
      },
      isTncAgreement: isFromRayaApps ? 'Y' : getState().auth.isTncAgreement
    };

    const header = {
      headers: {
        Authorization: getState().auth.VTtoken,
        'Content-Type': 'application/json'
      }
    };

    dispatch(setRegisteredPin(pin));

    const handleSuccess = () => {
      dispatch(setError(''));
      callback && callback('success');
    };

    axiosGolang
      .post(CUSTOM_USERS, body, header)
      .then(handleSuccess)
      .catch(err => {
        const status = err.response?.status;

        handleErrorCreatePin(err, status, callback, dispatch, pin);
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const createAccount = (auth, action) => {
  return async (dispatch, getState) => {
    const isFromRayaApps = getState()?.auth?.codeAuthFlowRaya;
    const encryptedPhone = await encryptRSA(auth.phoneNumber);
    const encryptedPin = await encryptRSA(auth.pin);
    const encryptedOtp = await encryptRSA(auth.otp);

    dispatch(loading(true));

    const diff = {
      deviceType: 'pg-wv-dc-typ-',
      deviceName: 'pg-wv',
      deviceId: 'pg-wv-dc-id-'
    };

    const body = {
      authenticationDetais: {
        oneTimePassword: encryptedOtp
      },
      deviceDetails: getDeviceDetails(auth.phoneNumber, diff),
      passwordDetails: {
        reTypesignOnPassword: encryptedPin,
        signOnPassword: encryptedPin,
        signOnPasswordFlag: 'Y',
        transactionPasswordFlag: 'Y'
      },
      userDetail: {
        userPhoneNumber: encryptedPhone
      },
      isTncAgreement: isFromRayaApps ? 'Y' : auth.isTncAgreement
    };

    const header = {
      headers: {
        Authorization: getState().auth.VTtoken,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .post(CUSTOM_USERS, body, header)
      .then(res => {
        handleSuccessCreateAccount(dispatch, res);
        action?.success?.();
      })
      .catch(err => {
        handleErrorCreateAccount(err, dispatch, action, auth);
      })
      .finally(() => dispatch(loading(false)));
  };
};

export const fetchOauthToken = (phoneNo, pin, action, history) => {
  return async dispatch => {
    const encryptedPhone = await encryptRSA(phoneNo);
    const encryptedPin = await encryptRSA(pin);

    const incorrectPinErrCodes = ['4000203', '4000202', '4030101'];
    const needResetErrCodes = ['106803', '24036', '4000008', '4000005'];

    const header = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    const formBody = {
      userId: encryptedPhone,
      userPin: pin ? encryptedPin : ''
    };

    dispatch(loading(true));
    axiosOauthGolang
      .post(OAUTH, formBody, header)
      .then(res => {
        if (res.data.accessToken) {
          dispatch(setForgotPinNewPinAlreadyUsed(false));
          dispatch(setOauthToken(res.data.accessToken, res.data.expiresIn));
          dispatch(validateToken(res.data.accessToken, action, pin));
        } else {
          // validate account is exist
          dispatch(loading(false));
          dispatch(setPhoneNo(phoneNo));
          dispatch(setApplicationStatus('FRESH_START'));
          history.push('/login');
        }
      })
      .catch(err => {
        if (
          incorrectPinErrCodes.includes(
            getChannelContextCode(err, 'channel-context')
          )
        ) {
          dispatch(setError('incorrect_pin'));
          dispatch(loading(false));
          return;
        }

        if (
          needResetErrCodes.includes(
            getChannelContextCode(err, 'channel-context')
          )
        ) {
          dispatch(setError('need_reset_pin'));
          dispatch(setPhoneNo(phoneNo));
          dispatch(loading(false));
          return;
        }

        //temporary locked due to multiple incorrect pin
        if (getChannelContextCode(err, 'channel-context') === '400502') {
          const addInfo = getChannelContextAdditionalInfo(
            err,
            'channel-context'
          );
          const freezeTime = addInfo?.freezeEnd;
          localStorage.setItem('pinFreeze', JSON.stringify({ freezeTime }));
          dispatch(setError('temporary_locked'));
          dispatch(loading(false));
          return;
        } else if (
          getChannelContextCode(err, 'channel-context') === '24037' ||
          getChannelContextCode(err, 'channel-context') === '4030001'
        ) {
          history &&
            history.push({
              pathname: '/account-deleted',
              state: {
                phoneDeleted: phoneNo
              }
            });
        } else if (
          getChannelContextCode(err, 'channel-context') === '4000006'
        ) {
          // user doesnt exist
          action && action();
        } else if (
          getChannelContextCode(err, 'channel-context') === '4000007'
        ) {
          dispatch(setError('have-change-number'));
        } else {
          localStorage.removeItem('phoneNo', '');
          localStorage.removeItem('phonePrincipal', '');
          dispatch(setError('system'));
        }

        dispatch(loading(false));
      });
  };
};

export const getPartnerToken = () => {
  return async dispatch => {
    try {
      dispatch(loading(true));

      const partnerId = await encryptRSA(getPartnerId);
      const header = {
        headers: {
          Authorization: partnerId
        }
      };

      const url = CUSTOM_PARTNER + '/token';

      const res = await axiosGolang.get(url, header);

      if (res.data.partnerToken) {
        setCookie('PARTNER_TOKEN', res.data.partnerToken, 10);
        dispatch(loading(false));
      }

      return res;
    } catch (err) {
      if (err.toString().includes('Network Error')) {
        dispatch(setError('connection'));
      } else {
        dispatch(setError('system'));
      }
      dispatch(loading(false));
    }
  };
};

export const validateToken = (token, action, pin) => {
  return async dispatch => {
    const encryptedPin = pin ? await encryptRSA(pin) : null;

    const formBody = pin ? { userPin: encryptedPin } : null;

    const header = {
      headers: {
        Authorization: token
      }
    };

    axiosOauthGolang
      .post(VALIDATE_TOKEN, formBody, header)
      .then(data => {
        const valueCheck = value => {
          return value ? value : '';
        };

        const userId = data.data?.ValidateTokenData?.userId.split('.')[0];

        dispatch(setUserId(valueCheck(userId)));
        dispatch(setPhoneNo(valueCheck(userId)));
        dispatch(
          setApplicationStatus(
            valueCheck(data.data?.ValidateTokenData?.appStatus)
          )
        );
        dispatch(
          setResulValidateToken({
            token: token,
            appStatus: valueCheck(data.data?.ValidateTokenData?.appStatus),
            status: 'success'
          })
        );

        action?.({
          token: token,
          appStatus: valueCheck(data.data?.ValidateTokenData?.appStatus),
          status: 'success'
        });
      })
      .catch(err => {
        if (
          getChannelContextCode(err, 'channel-context') === '24032' ||
          getChannelContextCode(err, 'channel-context') === '4000202'
        ) {
          dispatch(setError('incorrect_pin'));
          action?.({ token: '', appStatus: '', status: 'incorrect_pin' });
          dispatch(loading(false));
          return;
        } else if (getChannelContextCode(err, 'channel-context') === '120000') {
          dispatch(
            setResulValidateToken({
              token: '',
              appStatus: '',
              status: 'invalid_token'
            })
          );
          action?.({ token: '', appStatus: '', status: 'invalid_token' });
          dispatch(setOauthToken('', ''));
          dispatch(loading(false));
          return;
        } else if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
        dispatch(setOauthToken('', ''));
        dispatch(loading(false));
        dispatch(
          setResulValidateToken({ token: '', appStatus: '', status: 'failed' })
        );
        action?.({ token: '', appStatus: '', status: 'failed' });
      });
  };
};

export const authenticateUser = (phoneNo, pin, history) => {
  return async (dispatch, getState) => {
    const VTtoken = getState().auth.VTtoken;

    const encryptedPhone = await encryptRSA(phoneNo);
    const encryptedPin = await encryptRSA(pin);

    dispatch(loading(true));

    const header = {
      headers: { Authorization: VTtoken }
    };

    const formBody = {
      userId: encryptedPhone,
      userPin: encryptedPin
    };

    dispatch(loading(true));
    axiosOauthGolang
      .post(OAUTH, formBody, header)
      .then(res => {
        if (res.data.accessToken) {
          dispatch(setOauthToken(res.data.accessToken, res.data.expiresIn));
          history && history(res.data?.accessToken);
        }
      })
      .catch(err => {
        dispatch(loading(false));
        handleAuthError(err, dispatch, phoneNo, history);
      });
  };
};

export const fetchUserProfile = auth => {
  return dispatch => {
    dispatch(loading(true));
    const url = USERS + PROFILE;
    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        dispatch(setUserProfile(res.data));
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const fetchUserConsent = (token, param) => {
  return async dispatch => {
    dispatch(loading(true));

    const url = USER_CONSENT + `?consentType=${param}`;
    const header = {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .get(url, header)
      .then(res => {
        if (param === 'INFOPROMO') {
          const acceptPrivacy = res?.data?.data?.acceptPrivacy === 'Y';
          dispatch(setInfoPromoPermission(acceptPrivacy));
        }
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const updateUserConsent = (token, param, action) => {
  return async dispatch => {
    dispatch(loading(true));
    const url = USER_CONSENT;
    const header = {
      headers: {
        Authorization: token,
        'Content-Type': 'application/json'
      }
    };
    const body = {
      consentType: param.type,
      acceptPrivacy: param.payload
    };
    axiosGolang
      .put(url, body, header)
      .then(res => {
        const acceptPrivacy = res?.data?.data?.acceptPrivacy === 'Y';
        dispatch(setInfoPromoPermission(acceptPrivacy));
        action && action?.();
      })
      .catch(err => {
        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const updatePin = (auth, param, action) => {
  return async dispatch => {
    dispatch(loading(true));

    const encryptedOldPin = await encryptRSA(param.old_pin);
    const encryptedNewPin = await encryptRSA(param.new_pin);
    const encryptedConfirmPin = await encryptRSA(param.new_confirm_pin);

    const url = USERS + CHANGE_PIN;

    const header = {
      headers: {
        Authorization: auth.oauthToken,
        'Content-Type': 'application/json'
      }
    };

    const body = {
      changePasswordOption: AUTH_MODE,
      signOnPasswordDetails: {
        oldPassword: encryptedOldPin,
        newPassword: encryptedNewPin,
        confirmPassword: encryptedConfirmPin
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(() => {
        action && action();
        dispatch(loading(false));
      })
      .catch(err => {
        if (
          getChannelContextCode(err, 'channel-context') === '4000007' ||
          getChannelContextCode(err, 'channel-context') === '4000010'
        ) {
          dispatch(setError('weakpin'));
          return;
        }
        if (
          getChannelContextCode(err, 'channel-context') === '4000101' ||
          getChannelContextCode(err, 'channel-context') === '4000001'
        ) {
          dispatch(setError('same_password'));
          return;
        }

        if (err.toString().includes('Network Error')) {
          dispatch(setError('connection'));
        } else {
          dispatch(setError('system'));
        }
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const updatePhoneNumber = (auth, param, action) => {
  return async dispatch => {
    dispatch(loading(true));

    const encryptedNewPhone = await encryptRSA(auth.newPhoneNumber);
    const encryptedOtp = await encryptRSA(auth.otp);

    const buildHeader = auth => ({
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    });

    const buildRequestBody = param => {
      if (param.isFirst) {
        return {
          userDetails: { userPhoneNumber: encryptedNewPhone }
        };
      }

      return {
        authorizationDetails: param.isFaceCompare
          ? {
              photoSelfie: auth.photoSelfie
            }
          : {
              oneTimePassword: encryptedOtp
            },
        userDetails: {
          userPhoneNumber: encryptedNewPhone,
          requestId: localStorage.getItem('requestId')
        }
      };
    };

    const url = USERS + DEVICE_REG + CHANGE_PHONE_NUMBER;
    const header = buildHeader(auth);
    const body = buildRequestBody(param);

    axiosGolang
      .put(url, body, header)
      .then(res =>
        handleSuccessUpdatePhoneNumber(dispatch, param, auth, res, action)
      )
      .catch(err => handleErrorUpdatePhoneNumber(err, dispatch, auth, action))
      .finally(() => dispatch(loading(false)));
  };
};

export const syncMobileNumber = (auth, param, history) => {
  return async dispatch => {
    dispatch(loading(true));

    const encryptedFlexiPhone = await encryptRSA(param.flexiAccountPhoneNumber);
    const encryptedRayaPhone = await encryptRSA(param.rayaAccountPhoneNumber);

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    const body = {
      userDetails: {
        flexiAccountPhoneNumber: encryptedFlexiPhone,
        rayaAccountPhoneNumber: encryptedRayaPhone
      }
    };

    axiosGolang
      .post(SYNC_PHONE_NUMBER, body, header)
      .then(() => {
        dispatch(setPhoneNo(param.rayaAccountPhoneNumber));
        dispatch(setNewPhoneNo(param.rayaAccountPhoneNumber));
        history.push('/login');
      })
      .catch(err => handleErrorUpdatePhoneNumber(err, dispatch, auth))
      .finally(() => dispatch(loading(false)));
  };
};

export const validateIsRayaAgreement = (auth, body, action) => {
  return dispatch => {
    dispatch(loading(true));

    const url = CUSTOM_RAYANET + '/agreement';

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    axiosGolang
      .post(url, body, header)
      .then(res => {
        if (res) {
          action && action.action();
          return res;
        }
      })
      .catch(err => {
        dispatch(setOauthToken('', ''));
        dispatch(setErrorRayaAgreement(true));

        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }

        dispatch(setError('system'));
      })
      .finally(() => {
        dispatch(loading(false));
      });
  };
};

export const deviceLoginLocation = (auth, action, params) => {
  return async (dispatch, getState) => {
    getState().auth.error !== 'eod' && dispatch(loading(true));

    const url = CUSTOM_DEVICE_LOCATION;

    const header = {
      headers: {
        Authorization: auth.token,
        'Content-Type': 'application/json'
      }
    };

    const body = {
      deviceDetails: {
        mobileNo: auth.phoneNo,
        longitude: getState().auth.geoLocation?.longitude?.toString() || '',
        latitude: getState().auth.geoLocation?.latitude?.toString() || ''
      }
    };

    axiosGolang
      .put(url, body, header)
      .then(res => {
        if (res) {
          action && action();
          return res;
        }
      })
      .catch(err => {
        if (!err.response) {
          dispatch(setError('connection'));
          return;
        }

        dispatch(setError('system'));
      })
      .finally(() => {
        params?.loading === false && dispatch(loading(false));
      });
  };
};

export const logout = auth => {
  return dispatch => {
    dispatch(loading(true));

    const header = {
      headers: {
        Authorization: auth?.token
      }
    };

    axiosOauthGolang
      .post(LOGOUT, null, header)
      .then(() => {
        dispatch(resetLogout());
        localStorage.clear();
        dispatch(loading(false));
        location.reload();
      })
      .catch(() => {
        dispatch(setError('system'));
        dispatch(loading(false));
      });
  };
};
